import { AxiosInstance } from 'axios'
import MockAdapter from 'axios-mock-adapter'

export default function mockAxios(axios: AxiosInstance) {
  return new MockAdapter(axios, { delayResponse: 300 })
}
